<template>
    <div class="Msign">
        <mt-field label="你的姓名*" placeholder="请输入真实姓名" v-model="groupform.name"></mt-field>
        <mt-field label="联系电话*" placeholder="请输入联系电话" type="tel" v-model="groupform.mobile"></mt-field>
        <mt-field label="个人简介*" type="textarea" rows="8" v-model="groupform.content" placeholder="例：会计师从事财务工作8年以上，具有全面的财务专业知识、财务处理及财务管理经验。曾任职于深圳市XXX科技公司财务主管，参与过XXX项目。"></mt-field>
        <!-- <div class="button"> -->
        <router-link to="/MaddAdvisers">
            <mt-button type="primary">返回</mt-button>
        </router-link>
        <mt-button type="danger" @click="save">保存</mt-button>
        <!-- </div> -->
    </div>
</template>

<script>
    import { addConsultantJoin } from '../../api/api.js'
    import { Toast } from 'mint-ui';
    export default {
        name: 'Msign',
        data() {
            return {
                groupform: {
                    name: '',
                    mobile: '',
                    content: ''
                },
            }
        },
        methods: {
            save() {
                addConsultantJoin(this.groupform).then(res => {
                    if (res.status == 1) {
                        Toast({
                            message: '预约报名成功',
                            duration: 3000
                        });
                        this.$router.push('/MaddAdvisers')
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .Msign {
        text-align: center;
        margin-bottom: 4%;
    }
</style>



// WEBPACK FOOTER //
// src/components/mobile/Msign.vue